var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.73 15.23L7.79 12.29C7.61 12.11 7.39 12.02 7.13 12.02C6.87 12.02 6.65 12.11 6.47 12.29C6.27 12.49 6.17 12.725 6.17 12.995C6.17 13.265 6.26 13.49 6.44 13.67L10.1 17.33C10.26 17.49 10.47 17.57 10.73 17.57C10.99 17.57 11.2 17.49 11.36 17.33L18.56 10.13C18.74 9.95 18.83 9.73 18.83 9.47C18.83 9.21 18.73 8.98 18.53 8.78C18.35 8.6 18.125 8.51 17.855 8.51C17.585 8.51 17.35 8.61 17.15 8.81L10.73 15.23ZM12.5 24.5C10.8 24.5 9.22 24.195 7.76 23.585C6.3 22.975 5.03 22.13 3.95 21.05C2.87 19.97 2.025 18.7 1.415 17.24C0.805 15.78 0.5 14.2 0.5 12.5C0.5 10.82 0.805 9.25 1.415 7.79C2.025 6.33 2.87 5.06 3.95 3.98C5.03 2.9 6.3 2.05 7.76 1.43C9.22 0.81 10.8 0.5 12.5 0.5C14.18 0.5 15.75 0.81 17.21 1.43C18.67 2.05 19.94 2.9 21.02 3.98C22.1 5.06 22.95 6.33 23.57 7.79C24.19 9.25 24.5 10.82 24.5 12.5C24.5 14.2 24.19 15.78 23.57 17.24C22.95 18.7 22.1 19.97 21.02 21.05C19.94 22.13 18.67 22.975 17.21 23.585C15.75 24.195 14.18 24.5 12.5 24.5Z",
    fill: "#01985D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checked-circle.32db5822778af7227ded7cddee7d32e1.svg";
export { ForwardRef as ReactComponent };